import { render, staticRenderFns } from "./ReportsBase.vue?vue&type=template&id=c6423f66&"
import script from "./ReportsBase.vue?vue&type=script&lang=js&"
export * from "./ReportsBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports